<div class="wrapper-search-field">
  <button (click)="onClose()" mat-button>
    <ui-icon faName="arrow-left" faStyle="light"></ui-icon>
  </button>

  <input
    #inputElement
    (keydown)="onInputKeyDown($event)"
    [formControl]="searchFieldControl">

  <button (click)="clearInput()" mat-button>
    <ui-icon faName="xmark" faStyle="light"></ui-icon>
  </button>
</div>
